'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationParameterModalController = function ConfigurationParameterModalController($scope, $rootScope, JQXGridColumn, GridSettings, saveButtonUtilsService, advancedGridService, advancedHepPayloadService, advancedHepGridValidationService, advancedHepModalGridValidationService) {
  $scope.showGrid = false;
  $scope.disableRemovingFromServer = true;
  $scope.modalTitle = 'DTD Values';
  function mapFields(item) {
    var fields = {
      name: item.field,
      type: item.type,
      title: item.title
    };
    if (item.percentageFormat) {
      fields.percentageFormat = item.percentageFormat;
    }
    return fields;
  }
  function mapColumns(column) {
    return _.assign(column, {
      frozen: false,
      visible: true,
      width: column.width ? column.width : 'auto'
    });
  }
  function mapColumnsToFields(columns) {
    return _.chain(columns).map(function (item) {
      if (item.columns && item.columns.length) {
        return _.map(item.columns, function (nestedField) {
          return mapFields(nestedField);
        });
      } else {
        return mapFields(item);
      }
    }).flatten().value();
  }
  $scope.setUpGridConfig = function () {
    if ($scope.columns) {
      var columns = _.map($scope.columns, mapColumns);
      var fields = mapColumnsToFields($scope.columns);
      var gridConfig = {
        sortCriteria: [{
          field: 'readingTimeIntervalStart',
          direction: 'asc'
        }],
        gridId: 'configuration-parameters-advanced-modal',
        drawerMenu: {},
        columns: columns,
        fields: fields,
        editable: !$scope.readOnly
      };
      $scope.modalGridSettings = _.assign(new GridSettings(gridConfig), {
        isDynamic: true,
        dynamicFields: gridConfig.fields
      });
      $scope.modalTitle = 'Values for ' + (_.isEmpty($scope.subTypeLabel) ? $scope.typeLabel : $scope.subTypeLabel);
    }
  };
  $scope.getFieldDataFromRow = function () {
    if ($scope.parentRow && $scope.parentFieldName) {
      var fieldDataFromRow = _.cloneDeep($scope.parentRow[$scope.parentFieldName]);
      decorateWithFieldFromParentGrid(fieldDataFromRow);
      return fieldDataFromRow || [];
    }
    return [];
  };
  function decorateWithFieldFromParentGrid(fieldDataFromRow) {
    if ($scope.parentFieldName) {
      if ($scope.parentFieldName === 'fareBrandDefinitionParams' && $scope.parentRow.carrier) {
        _.forEach(fieldDataFromRow, function (fieldData) {
          fieldData.carrier = $scope.parentRow.carrier;
        });
      }
      if ($scope.parentFieldName === 'businessRulesProperties' || $scope.parentFieldName === 'fareClassMappingProperties') {
        _.forEach(fieldDataFromRow, function (fieldData) {
          fieldData.hostCarrier = $scope.parentRow.hostCarrier;
          fieldData.cabin = $scope.parentRow.foCabin;
          fieldData.origin = $scope.parentRow.origin;
          fieldData.destination = $scope.parentRow.destination;
          fieldData.category = $scope.parentRow.category;
        });
      }
      if ($scope.parentFieldName === 'applicableDateMappingProperties') {
        _.forEach(fieldDataFromRow, function (fieldData) {
          fieldData.category = $scope.parentRow.category;
        });
      }
      if ($scope.parentFieldName === 'fareBasisCodePatternProperties') {
        _.forEach(fieldDataFromRow, function (fieldData) {
          fieldData.category = $scope.parentRow.adaptivePricingCategory;
        });
      }
      if ($scope.parentFieldName === 'rbdAssignmentCompFareClassList') {
        _.forEach(fieldDataFromRow, function (fieldData) {
          fieldData.hostCarrier = $scope.parentRow.hostCarrier;
          fieldData.origin = $scope.parentRow.origin;
          fieldData.destination = $scope.parentRow.destination;
          fieldData.category = $scope.parentRow.category;
          fieldData.cabin = $scope.parentRow.foCabin;
          fieldData.rbdMethod = $scope.parentRow.rbdMethod;
          fieldData.ladderMethod = $scope.parentRow.ladderMethod;
        });
      }
    }
  }
  $scope.setUpData = function () {
    $scope.parentRow = $scope.eventData && $scope.eventData.entityData;
    $scope.parentFieldName = $scope.eventData && $scope.eventData.fieldId;
    $scope.modalGridData = $scope.getFieldDataFromRow();
    $scope.modalGridDataBeforeChange = _.cloneDeep($scope.modalGridData);
  };
  $scope.isInfoEnabled = function () {
    var infoMessages = {
      businessRulesProperties: 'Host RBD value is not applicable and if entered, will be ignored when the RBD Assignment method is VALUE BASED. Specify if you want the configurations to apply for host fare recommendations for specific Tariff(s)',
      applicableDateMappingProperties: 'Split on Struc is not applicable when the RBD Assignment method is VALUE BASED. Specify if you want the configurations to apply for host fare recommendations for specific Tariff(s)',
      foRBDLevelFareThresholdPropertiesList: 'Specify if you want the configurations to apply for host fare recommendations for specific Tariff(s).',
      ruleMappingDOWPropertiesList: 'Specify if you want the configurations to apply for host fare recommendations for specific Tariff(s).',
      ruleMappingAPPropertiesList: 'Specify if you want the configurations to apply for host fare recommendations for specific Tariff(s).',
      ruleMappingMinStayPropertiesList: 'Specify if you want the configurations to apply for host fare recommendations for specific Tariff(s).',
      ruleMappingMaxStayPropertiesList: 'Specify if you want the configurations to apply for host fare recommendations for specific Tariff(s).',
      rbdAssignmentCompFareClassList: 'Specify if you want the configurations to apply for host fare recommendations for specific Tariff(s). If Tariff is mentioned make sure that all the applicable RBDs are configured for the specified tariff.',
      surchargeManagementProperties: 'Specify if you want the configurations to apply for specific Tariff(s)',
      tacticalFareDefinitionPropertiesList: 'Specify if you want the configurations to apply for specific Tariff(s)',
      taxOverridePropertiesList: 'Specify if you want the configurations to apply for specific Tariff(s)'
    };
    if (infoMessages[$scope.parentFieldName]) {
      $scope.infoText = infoMessages[$scope.parentFieldName];
      return true;
    }
    return false;
  };
  $scope.cancelModal = function () {
    $scope.hideModal();
  };
  $scope.getCancelButtonName = function () {
    return $scope.readOnly ? 'Close' : 'Cancel';
  };
  $scope.applyChangesToRow = function () {
    $rootScope.$broadcast('grid:setCellValue', {
      rowId: $scope.parentRow.uid,
      columnName: $scope.parentFieldName,
      newValue: _.cloneDeep($scope.modalGridData),
      oldValue: $scope.getFieldDataFromRow(),
      gridId: 'configuration-parameters-advanced',
      refreshOnly: false
    });
  };
  function transformPercentageValuesForValidation(rows, percentageFields) {
    if (_.isEmpty(percentageFields)) {
      return rows;
    }
    return _.transform(rows, function (result, row) {
      _.forOwn(row, function (value, key) {
        if (percentageFields.indexOf(key) !== -1) {
          row[key] = value * 100;
        }
      });
      result.push(row);
    });
  }
  function getPercentageFields(columns) {
    return _.chain(columns).filter({
      renderer: 'percentageRender'
    }).map('field').value();
  }
  $scope.isValid = function () {
    var allRows = _.cloneDeep($scope.modalGridData);
    var editedRows = saveButtonUtilsService.getEditedRowsFromData(allRows);
    var percentageFields = getPercentageFields($scope.modalGridSettings.columns);
    return advancedHepGridValidationService.areColumnsValidationsFulfilled(transformPercentageValuesForValidation(editedRows, percentageFields), transformPercentageValuesForValidation(allRows, percentageFields), $scope.modalGridSettings.columns, $scope.$parent.selected) && advancedHepModalGridValidationService.areModalColumnValidationsFulfilled(editedRows, allRows, $scope.$parent.selected.type);
  };
  $scope.isChange = function () {
    return !_.isEmpty(saveButtonUtilsService.getEditedRowsFromData($scope.modalGridData)) || $scope.modalGridData.length < $scope.modalGridDataBeforeChange.length;
  };
  $scope.saveModal = function () {
    if ($scope.isValidationMessage()) {
      return;
    }
    if ($scope.isValid()) {
      if ($scope.isChange()) {
        $scope.applyChangesToRow();
      }
      $scope.hideModal();
    } else {
      if (!advancedHepGridValidationService.isCustomValidationType($scope.$parent.selected)) {
        toastr.error('Validation error occurred');
      }
    }
  };
  $scope.$watch('isModalShown', function () {
    if ($scope.isModalShown) {
      $scope.setUpGridConfig();
      $scope.setUpData();
      $scope.isInfoEnabled();
      $scope.showModal();
    }
  });
};
ConfigurationParameterModalController.$inject = ['$scope', '$rootScope', 'JQXGridColumnFactory', 'GridSettingsFactory', 'SaveButtonUtilsService', 'AdvancedHepGridService', 'AdvancedHepPayloadService', 'AdvancedHepGridValidationService', 'AdvancedHepModalGridValidationService'];
module.exports = ConfigurationParameterModalController;